<template>
    <div class="main">
        <c-panel title="MOTIVOS" titleIcon="fas fa-tags">
            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Cadastro único e tipificado. Os fluxos de remanejamento, reclassificação e dispensa passam a exigir um motivo desta lista."></el-alert>

            <el-row class="u-mb-15" :gutter="10">
                <el-col :xs="24" :sm="10"><el-input v-model="filtro.nome" placeholder="Pesquisar motivo..." @keyup.native.enter="carregar"></el-input></el-col>
                <el-col :xs="24" :sm="8">
                    <el-select v-model="filtro.tipo" clearable placeholder="Tipo" style="width: 100%;" @change="carregar">
                        <el-option v-for="t in tipos" :key="t" :value="t" :label="rotuloTipo(t)"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="6" class="u-text-right">
                    <router-link v-if="podeEscrever" to="/admin/motivo/cadastro" class="btn-new-register">
                        <el-button type="primary">NOVO MOTIVO</el-button>
                    </router-link>
                </el-col>
            </el-row>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Motivo</th>
                            <th>Tipo</th>
                            <th class="u-text-center hidden-mobile">Exige justificativa</th>
                            <th class="u-text-center hidden-mobile">Exige documento</th>
                            <th class="u-text-center">Situação</th>
                            <th class="u-text-center" style="width: 120px;">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="m in items" :key="m.id">
                            <td>{{ m.nome }}</td>
                            <td>{{ rotuloTipo(m.tipo) }}</td>
                            <td class="u-text-center hidden-mobile">{{ m.exige_justificativa ? 'Sim' : 'Não' }}</td>
                            <td class="u-text-center hidden-mobile">{{ m.exige_documento ? 'Sim' : 'Não' }}</td>
                            <td class="u-text-center">{{ m.situacao ? 'Ativo' : 'Inativo' }}</td>
                            <td class="u-text-center acao">
                                <router-link v-if="podeEscrever" :to="'/admin/motivo/edit/' + m.id" class="link-icon u-mr-10" style="color: rgba(0,0,0,.87) !important;">
                                    <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                                </router-link>
                                <el-button v-if="podeEscrever" @click="excluir(m.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                                <span v-if="!podeEscrever">—</span>
                            </td>
                        </tr>
                        <tr v-if="items.length === 0"><td colspan="6" class="u-text-center">Nenhum motivo cadastrado.</td></tr>
                    </tbody>
                </table>
                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>
            </div>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO E — item 33. Interface para `api/motivo`. */
export default {
    data: () => ({ statusList: false, filtro: { nome: '', tipo: '' }, items: [], tipos: [] }),
    computed: {
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () {
        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/motivo/initForm`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.tipos = (r.data && r.data.tipos) ? r.data.tipos : [] }).catch(() => {})
        this.carregar()
    },
    methods: {
        carregar () {
            this.statusList = false
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/motivo/getAllPaginate?page=1`,
                this.filtro, this.$store.getters.getHeaderAuth
            ).then(r => { this.items = r.data.data || []; this.statusList = true })
             .catch(e => this.$store.commit('throwException', e))
        },
        rotuloTipo (t) {
            return { movimentacao_matricula: 'Movimentação de matrícula', remanejamento: 'Remanejamento',
                dispensa_componente: 'Dispensa de componente', cancelamento: 'Cancelamento',
                reclassificacao: 'Reclassificação' }[t] || t
        },
        excluir (id) {
            this.$confirm('Excluir este motivo?', 'Confirmação', {
                confirmButtonText: 'Excluir', cancelButtonText: 'Cancelar', type: 'warning'
            }).then(() => {
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/motivo/delete/${id}`,
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Motivo excluído.', type: 'success' })
                    this.carregar()
                }).catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
